<template>
  <div class="sections">
    <div
      class="section"
      v-for="(section, idx) in sections"
      :key="section.title"
    >
      <div
        v-if="section.title"
        class="section-title"
      >
        <p class="idx-text">
          {{ getIndexing(idx) }}<span v-if="level === 1">.</span>
        </p>
        <p>{{ section.title }}</p>
      </div>
      <div
        class="section-content"
        :class="{'align-by-title':section.title}"
        v-if="section.content"
      >
        <p
          class="idx-text"
          v-if="!section.title && !autoIndexOff"
        >{{ getIndexing(idx) }}</p>
        <p v-html="contentTransform(section.content)" />
      </div>
      <div
        class="section-content"
        v-if="section.contentByIndex"
      >
        <p v-html="indexedContentTransform(idx, section.contentByIndex)" />
      </div>
      <TermSections
        v-if="section.sections"
        :sections="section.sections"
        :level="level + 1"
        :indexText="section.omitPrevIndex ? '' : getIndexing(idx)"
        :indexDelimiter="section.delimiter"
        :autoIndexOff="section.autoIndexOff"
      />
      <p
        class="remnant-content"
        v-if="section.remnantContent"
      >{{ section.remnantContent }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermSections',
  props: {
    sections: {
      type: Array,
    },
    level: {
      type: Number,
      default: 1,
    },
    indexText: {
      type: String,
      default: '',
    },
    indexDelimiter: {
      type: String,
      default: '.',
    },
    autoIndexOff: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getIndexing (index) {
      return this.autoIndexOff ? '' : [this.indexText, (index + 1)].join(this.indexDelimiter)
    },
    contentTransform (content) {
      return Array.isArray(content) ? content.join('<br><br>') : content
    },
    indexedContentTransform (index, content) {
      return this.getIndexing(index) + ' ' + this.contentTransform(content)
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding-left: 2.5rem;
  .align-by-title {
    padding-left: 2.5rem;
  }
  .idx-text {
    margin-right: 0.5rem;
  }
  .section-title {
    display: flex;
    font-weight: bold;
    margin-top: 1rem;
  }
  .section-content, .remnant-content{
    display: flex;
  }
}
</style>
